<script>
  import { Lock } from 'lucide-svelte'
  import Button from '@components/buttons/button.svelte'

  let { title = "Premium content", description = "Upgrade your membership to watch this video", buttonText = "Upgrade membership" } = $props()
</script>

<div class="w-full aspect-video rounded-lg border border-gray-200 bg-gray-50 flex flex-col items-center justify-center gap-3">
  <Lock size={40} class="text-gray-400" />
  <p class="text-gray-800 font-medium text-lg">{title}</p>
  <p class="text-gray-500 text-sm">{description}</p>
  <Button variant="primary" path="/register" text={buttonText} class="mt-2" />
</div>
